import NewRegistrationComponent from "./components/NewRegistrationComponent";
import MeaPage from "../../../components/MeaPage";
import NewRegistrationFormComponent from "./components/NewRegistrationFormComponent";
import { useParams } from "react-router-dom";

const NewRegistrationPage = () => {
    //      
    const params = useParams();
    const schoolId = params.schoolId
    const trainingId = params.registrationId;
    //
    return (
        <MeaPage
            //breadcrumb={<BreadCrumb model={[{ label: 'Les inscriptions' }]} home={{ icon: 'pi pi-home', url: '/' }} />}
            title="Nouveau dossier d'inscription"
            subtitle="Créer un nouveau dossier d'inscription pour cette formation"
        >
            <NewRegistrationFormComponent schoolId={schoolId} trainingId={trainingId} />
        </MeaPage>
    );
}

export default NewRegistrationPage;
